import { useEffect, useState } from 'react';
import './Trademarks.css';
import { getTrademarkApplications } from '../../utilities/api/trademarkApplications';
import TrademarkApplicationsList from '../../components/TrademarkApplicationsList/TrademarkApplicationsList';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

export default function Trademarks({ user, isMobile }) {
  const [loading, setLoading] = useState(false)
  const [trademarkApplications, setTrademarkApplications] = useState([])
  const [trademarkSortOrder, setTrademarkSortOrder] = useState('desc')
  const [trademarkSortHeader, setTrademarkSortHeader] = useState('createdAt')


  const getApplications = async () => {
    setLoading(true)
    try {
      const allTrademarkApplications = await getTrademarkApplications(user)
      setTrademarkApplications(allTrademarkApplications.sort((a, b) => a[trademarkSortHeader] < b[trademarkSortHeader] ? 1 : -1))
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  const updateTrademarkApplications = (updatedData) => {
    updatedData.sort((a, b) => {
      if (trademarkSortOrder === 'asc') {
          return ((typeof(a[trademarkSortHeader])==='string' ? a[trademarkSortHeader].toLowerCase() : a[trademarkSortHeader]) > (typeof(b[trademarkSortHeader])==='string' ? b[trademarkSortHeader].toLowerCase() : b[trademarkSortHeader])) ? 1 : -1
      } else {
          return ((typeof(a[trademarkSortHeader])==='string' ? a[trademarkSortHeader].toLowerCase() : a[trademarkSortHeader]) < (typeof(b[trademarkSortHeader])==='string' ? b[trademarkSortHeader].toLowerCase() : b[trademarkSortHeader])) ? 1 : -1
      }
    });
    setTrademarkApplications(updatedData)
  }


  useEffect(() => {
    getApplications()
    // eslint-disable-next-line
  },[])

  return (
    <div className='Trademarks'>
      <div className='applicationsHeadingContainer'>
        <div className='headerContent'>
            <img src='https://project-intake-assets.s3.ca-central-1.amazonaws.com/Skin.png' alt="" />
            <div className='mainHeaderContent'>
                <div className='companyName'>
                    {capitalizeFirstLetter(user.companyName)}
                </div>
                <div className='instructions'>
                    Below is a list of all your <strong>Trademark Applications</strong>.
                </div>
            </div>
        </div>
      </div>
      { loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='applicationsMainSection'>
        {(trademarkApplications && trademarkApplications.length === 0) ?
        <div className='emptyList'>
          <div className='text-center'>
              <h4 className='errorText pt-3'>No Trademark Applications</h4>
          </div>
        </div>
        :
        <TrademarkApplicationsList 
        user={user} 
        trademarkApplications={trademarkApplications}
        updateTrademarkApplications={updateTrademarkApplications}
        sortHeader={trademarkSortHeader}
        setSortHeader={setTrademarkSortHeader}
        sortOrder={trademarkSortOrder}
        setSortOrder={setTrademarkSortOrder}
        isMobile={isMobile} />
        }
      </div>
      }
    </div>
  )
}
